<script setup lang="ts">
import { onMounted } from 'vue'
import IconWarning from './icons/IconWarning.vue'
import { ref, onUnmounted, computed } from 'vue'
import { DEV_TOOLS_VERSION_ALERT_QUERY } from '@/util/dev-tools.constants'

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  details: {
    type: String,
    required: true
  }
})

let counter = ref(30)
let interval: ReturnType<typeof setInterval> | null = null
const dynamicTitle = computed(() => {
  return props.title.replace('{count}', counter.value.toString())
})

let refreshPage = async () => {
  const url = new URL(window.location.href)
  url.searchParams.delete(DEV_TOOLS_VERSION_ALERT_QUERY)
  window.location.href = url.toString()
}

onMounted(async () => {
  interval = setInterval(() => {
    counter.value -= 1
    if (counter.value <= 0) {
      if (interval) {
        clearInterval(interval)
      }
      refreshPage()
    }
  }, 1000)
})

onUnmounted(() => {
  if (interval) {
    clearInterval(interval)
  }
})
</script>
<template>
  <div class="alert-banner">
    <div class="alert-banner-icon">
      <IconWarning color="#D97706" />
    </div>
    <div class="alert-banner-content">
      <h4 class="alert-banner-title">{{ dynamicTitle }}</h4>
      <p class="alert-banner-details">{{ details }}</p>
    </div>
    <div class="alert-banner-right">
      <v-btn class="update-now-btn" variant="text" @click="refreshPage"> Update Now </v-btn>
    </div>
  </div>
</template>

<style scoped>
.alert-banner {
  background-color: #fffcf1;
  padding: 16px;
  border: 1px solid #ff7e00;
  border-radius: 16px;
  display: flex;
}

.alert-banner-icon {
  display: inline-flex;
  align-items: center;
}

.alert-banner-content {
  margin-left: 12px;
}

.alert-banner-title {
  font-size: 16px;
  font-weight: 600;
  color: #050f2d;
}

.alert-banner-details {
  font-size: 14px;
  font-weight: 400;
  color: #050f2d;
}

.alert-banner-right {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.update-now-btn {
  background-color: #fff;
  border: 1px solid #d97706;
  text-transform: none;
  border-radius: 4px;
  padding-right: 12px;
}
</style>
